import React, { } from "react";
import { Row, Col } from 'reactstrap';
import { Modal, ModalBody } from 'reactstrap';


const Carriers = (props) => {
    const onCloseModal = e => {
        props.setShowCarriers(false);
    }
    return (
        <Modal isOpen={true} scrollable={true} size="lg">
            <ModalBody>
                <button
                type="button"
                className="close btnCarrierClose"
                onClick={() => onCloseModal()}
            >×</button>
                <h3>Participating Carriers</h3>
                <p>
                Our participating carriers are:
                </p>
                <p>
                AT&T
                <br />
                Sprint/Boost/Virgin
                <br />
                T-Mobile/MetroPCS
                <br />
                Verizon Wireless
                <br />
                CellCom USA
                <br />
                C Spire Wireless
                <br />
                U.S. Cellular
                <br />
                Carolina West Wireless (CWW)
                <br />
                Google Voice
                <br />
                ACS/Alaska
                <br />
                Advantage Cellular (DTC Wireless)
                <br />
                Appalachian Wireless
                <br />
                Bluegrass Cellular
                <br />
                Cellular Network Partnership (PIONEER)
                <br />
                Cellular One of East Central Illinois
                <br />
                Chat Mobility USA
                <br />
                Coral Wireless (Mobi PCS)
                <br />
                Element Mobile (Flat Wireless)
                <br />
                Epic Touch (Elkhart Telephone)
                <br />
                GCI Communications Corp
                <br />
                Golden State Cellular
                <br />
                Illinois Valley Cellular (IV Cellular)
                <br />
                i Wireless (IOWA Wireless)
                <br />
                Nex-Tech Wireless
                <br />
                MTA Communications
                <br />
                MTPCS (Cellular One Nation)
                <br />
                Cross Telephone Company (MBO Wireless)
                <br />
                Duet IP (Maximum Communications Core Wireless)
                <br />
                Inland Cellular Telephone Company
                <br />
                Immix (Keystone Wireless)
                <br />
                Mosaic (Consolidated or CTC Telecom)
                <br />
                Northwest Missourri Cellular Limited
                <br />
                Peoples Wireless
                <br />
                Panhandle Telecommunications Systems (PTCI)
                <br />
                RINA
                <br />
                Revol Wireless USA
                <br />
                SI Wireless/Mobile Nation
                <br />
                SRT Wireless
                <br />
                Texas RSA 3 Ltd (Plateau Wireless)
                <br />
                Thumb Cellular
                <br />
                United Wireless
                <br />
                Union Telephone Company (Union Wireless)
                <br />
                Viaero Wireless
                <br />
                West Central Wireless (5 Star Wireless)
                <br />
                Sagebrush Cellular (Nemont)
                <br />
                Pine Cellular
                <br />
                Aio Wireless/Cricket
                <br />
                SouthernLinc
                <br />
                Bandwidth
                <br />
                Copper Valley
                <br />
                Leaco
                <br />
                Cable Vision
                <br />
                Buffalo Wireless
                <br />
                Chariton Valley Cellular
                <br />
                Pine Belt Wireless
                <br />
                Atlantic Tele-Network International (ATN)
                </p>
            </ModalBody>
        </Modal>
    )
}

export default Carriers;
